import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getMakeRequest: ["make_id"],
  getMakeSuccess: ["dataMake"],
  getMakeFailure: null,
});

export const GetMakeTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  make_id: null,
  fetching: null,
  success: null,
  dataMake: null,
  error: null,
});

export const GetMakeSelectors = {
  getData: (state: any) => state.getMake.data,
  isFetching: (state: any) => state.getMake.fetching,
  isSuccess: (state: any) => state.getMake.success,
  hasError: (state: any) => state.getMake.error,
};

export const request = (state: any, { make_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    make_id,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { dataMake } = action;
    const updateData = {
    fetching: false,
    success: true,
    error: false,
    dataMake: dataMake?.data,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    dataMake: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_MAKE_REQUEST]: request,
  [Types.GET_MAKE_SUCCESS]: success,
  [Types.GET_MAKE_FAILURE]: failure,
});
